import React, { Component } from "react";
import VerticalLine from "../VerticalLine";
import HorizontalLine from "../HorizontalLine";
import ReactSpeedometer from "react-d3-speedometer";
import ChevronDown from "mdi-react/ChevronDownIcon";
import ReactMeter from "../ReactMeter";
// import "./contractsListItem.scss";

export default class ContractsListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract: this.props.contract
    };
  }

  getNameInitials(name) {
    const arr = name.split(" ");
    return arr[0][0] + (arr.length > 1 ? arr[1][0] : "");
  }

  render() {
    const data = this.state.contract;
    return (
      <div className="contract-item-container">
        <div className="company-section">
          <div className="logo-box">
            <div style={{ backgroundColor: data.bg_clr }}>
              {this.getNameInitials(data.counter_party_name)}
            </div>
          </div>
          <div className="footer-name normal-text">
            <span>{data.counter_party_name}</span>
          </div>
        </div>

        <div className="valuation-section">
          <div className="normal-text">Contract Valuation</div>
          <div className="emphasized-text">{"$" + data.value}</div>
          <HorizontalLine className="horizontal-line" />
          <div className="normal-text">Type</div>
          <div className="emphasized-text">{data.type}</div>
        </div>
        <VerticalLine className="vertical-line" />

        <div className="version-section">
          <div>
            <span className="bold-text">Version</span>
            <span className="normal-text">{data.version}</span>
          </div>
          <div>
            <span className="bold-text">Entity</span>
            <span className="normal-text">{data.entity}</span>
          </div>
          <div>
            <span className="bold-text">Sector</span>
            <span className="normal-text">{data.sector}</span>
          </div>
        </div>
        <VerticalLine className="vertical-line" />

        <div className="duration-section">
          <div className="normal-text">Duration</div>
          <div className="emphasized-text">{data.duration}</div>
        </div>
        <VerticalLine className="vertical-line" />

        <div className="date-section">
          <div className="date-container">
            <div>
              <span className="bold-text">Start Date</span>
              <span className="normal-text">{data.start_at}</span>
            </div>
            <div>
              <span className="bold-text">End Date</span>
              <span className="normal-text">{data.end_at}</span>
            </div>
          </div>
          <div className="risk-meter">
            {/* <div className="risk-score">{`${data.risk}%`}</div> */}

            <ReactMeter className={""} label="Risk" value={data.risk_score} />
            {/* <ReactSpeedometer
              needleHeightRatio={0.45}
              maxSegmentLabels={0}
              ringWidth={16}
              fluidWidth={true}
              valueTextFontSize={"0px"}
              needleColor={"#666"}
              segments={1000}
              value={data.risk * 10}
              endColor={"#eb1515"}
              startColor={"#3fe821"}
            /> */}
            <div className={"risk-score"}>Risk Score</div>
          </div>
        </div>
        <div onClick={this.props.onClick} className="contract-title">
          <p class="_title-content">{data.title}</p>
          <VerticalLine className="vertical-line-title" />
          <div id="_id">{"ID " + data.id}</div>
        </div>
        <div className="_arrow-down">
          <ChevronDown color="#fff" size="20px" />
        </div>
      </div>
    );
  }
}
